module.exports = __webpack_public_path__ + "static/media/info.7cac0acc.png";